<template>
  <div class="">
    <div class="text-center title1 d-none d-sm-block">
      Cursos Destacados
    </div>
    <div class="col-12 row mx-0 justify-content-center box-carrousel">
      <div class="max-1200 d-block">
        <VueSlickCarousel v-if="course.length" v-bind="settings">
          <div  v-for="(element, index) in course" :key="index" v-if="element.destacate == 'true'">
            <item :item="element" />
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import item from "../../components/Item.vue";
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "destacate",
  props: ["course"],
  components: {
    item,
    VueSlickCarousel
  },
  created() {},
  data() {
    return {
      items: [],
      model: 0,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        autoplay: true,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1224,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState
  },
  methods: {}
};
</script>
<style scoped>
.static-heaer {
  height: 342px;
}

.box-carrousel {
  padding-top: 30px;
  height: 480px;
  background: transparent linear-gradient(90deg, #446daf 0%, #de337a 100%) 0% 0%
    no-repeat padding-box;
  background-image: url("/image/resource/background.jpg");
  background-size: cover;
}

::v-deep .agile__list {
  padding-bottom: 10px !important;
}

::v-deep .carousel-3d-container,
.carousel-3d-slide {
  height: 580px !important;
}

::v-deep .carousel-3d-slide {
  border: none;
  background-color: transparent;
  display: none;
  justify-content: center;
}

.max-1200 {
  max-width: 1200px;
  width: 100vw;
}

.title1 {
  margin-top: 34px;
  margin-bottom: 31px;
  font-size: 38px;
  font-family: "Roboto-Bold", sans-serif;
  color: #446daf;
  font-weight: bold;
  line-height: 60px;
}

::v-deep .left-1,
.right-1 {
  opacity: 0.5 !important;
}

::v-deep .left-1,
.right-1,
.current {
  display: flex !important;
}

::v-deep .left-1 {
  transform: translateX(240px) translateZ(-420px) rotateY(-5deg) !important;
}

::v-deep .right-1 {
  transform: translateX(-240px) translateZ(-420px) rotateY(5deg) !important;
}

@media (min-width: 481px) and (max-width: 767px) {
  .static-heaer {
    height: auto;
  }
}
@media (min-width: 300px) and (max-width: 767px) {
  .title1 {
    margin-top: 10px !important;
    margin-bottom: 30px !important;
  }
}

@media (min-width: 760px) and (max-width: 1199px) {
  .title1 {
    height: auto;
    margin-top: -110px;
  }
}

@media (min-width: 120px) and (max-width: 480px) {
  .item-header2 {
    text-align: center;
    color: white;
    display: flex;
    flex-direction: row;
    font-size: 2rem;
    align-content: center;
    text-shadow: 2px 2px 2px #0f4f84;
    font-family: "Gayathri", sans-serif;
    background-image: linear-gradient(to right, #3b61e5, #214fe3);
    justify-content: center;
  }

  ::v-deep .left-1 {
    transform: translateX(150px) translateZ(-420px) rotateY(-5deg) !important;
  }

  ::v-deep .right-1 {
    transform: translateX(-150px) translateZ(-420px) rotateY(5deg) !important;
  }

  .item-header {
    display: none;
  }

  .b-title {
    font-size: 10rem;
    line-height: 8rem;
    font-weight: 800;
  }
}
</style>
